import React from "react";
import { ChevronDownIcon } from "staysure-component-library";

import Accordion from "@/components/atoms/accordion/accordion";

type AccordionItemSectionProps = {
  title: string;
  medicals: string[];
  isExpand?: boolean;
  id: string;
};

function AccordionItemSection({
  title,
  medicals,
  isExpand = false,
  id,
}: Readonly<AccordionItemSectionProps>) {
  const [isExpanded, setIsExpanded] = React.useState(isExpand);
  return (
    <Accordion
      className="!p-0"
      contentClassName="!mt-spacing-xs"
      buttonClassName={`${medicals.length > 0 ? "" : "cursor-default"}`}
      title={
        <h2 className="font-body-font font-[700] text-interactive-secondary-default text-xs leading-[150%] text-left">
          {title}
        </h2>
      }
      content={
        <div className="flex flex-col gap-spacing-xxs lg:gap-spacing-xs">
          {medicals.map((medical) => (
            <p
              key={medical}
              className="text-text-body font-body-font text-2xs leading-[150%] font-[400]"
            >
              {medical}
            </p>
          ))}
        </div>
      }
      isexpanded={isExpanded && medicals.length > 0}
      isShow={medicals.length !== 0}
      onClick={() => setIsExpanded(!isExpanded)}
      icon={<ChevronDownIcon stroke="#306582" />}
      id={id}
    />
  );
}

export default AccordionItemSection;
